import { AppState } from "../../reducers";
import { CountriesState } from "./countriesSlice";

export const countriesSelector = (state: AppState): CountriesState => {
  return state.countries;
};
